import {useState, useEffect} from 'react'

const useScriptLoader = (url) => {
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const script = document.createElement('script')
        script.src = url
        script.defer = true

        const onLoad = () => {
            setLoading(false)
        }

        const onError = () => {
            setLoading(false)
            setError(new Error(`Failed to load script: ${url}`))
        }

        script.onload = onLoad
        script.onerror = onError

        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [url])

    return [loading, error]
}

export default useScriptLoader
